module.exports = __webpack_public_path__ + "img/u3.f48f886f.svg";